<div class="si-wrapper" tabindex="0">
    <div class="si-container">
        <header class="nf-page-header">
            <button type="button" class="nf-page-header__back" (click)="back()">
                <svg aria-hidden="true" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M15 6l-6 6 6 6" />
                </svg>
                Back to services
            </button>
            <div class="nf-page-header__titlerow">
                <h1 class="nf-page-header__title">Create identities for sources</h1>
            </div>
            <p class="nf-page-header__subtitle">Grant access by identity instead of by source IP.</p>
        </header>

        @if (rows.length) {
        <!-- Step 1: the role every minted identity carries, and the service that grants it. -->
        <section class="nf-panel si-step">
            <div class="si-step__head">
                <span class="si-step__num" aria-hidden="true">1</span>
                <div class="si-step__heading">
                    <h2 class="si-step__title">Name the access role</h2>
                    <p class="si-step__desc">
                        Every new identity carries this role attribute; the service grants it on its access policy.
                    </p>
                </div>
            </div>
            <div class="si-step__body">
                @if (grantedServices.length) {
                <div class="si-field">
                    <span class="si-field__label">Grants access to</span>
                    <span class="si-field__chips">
                        @for (svc of grantedServices; track svc) {
                        <span class="si-svcchip">{{ svc }}</span>
                        }
                    </span>
                </div>
                }
                <div class="si-field">
                    <label class="si-field__label" for="si-attr">Role attribute</label>
                    <div class="si-input">
                        <span class="si-input__hash" aria-hidden="true">#</span>
                        <input id="si-attr" class="si-input__field" type="text" [(ngModel)]="roleAttribute"
                            spellcheck="false" autocomplete="off" />
                    </div>
                </div>
            </div>
        </section>

        <!-- Step 2: pick which source addresses become identities. -->
        <section class="nf-panel si-step">
            <div class="si-step__head">
                <span class="si-step__num" aria-hidden="true">2</span>
                <div class="si-step__heading">
                    <h2 class="si-step__title">Choose which sources get an identity</h2>
                    <p class="si-step__desc">Each selected source address becomes its own Ziti identity.</p>
                </div>
                <div class="si-step__meta">
                    <span class="si-count">{{ includedCount }} of {{ rows.length }} selected</span>
                    <button type="button" class="si-link" (click)="toggleAll()">
                        {{ allIncluded ? 'Clear all' : 'Select all' }}
                    </button>
                </div>
            </div>

            <div class="si-rowswell">
                <div class="si-rows">
                    @for (row of rows; track row.address) {
                    <label class="si-row" [class.si-row--off]="!row.include">
                        <input class="si-row__check" type="checkbox" [(ngModel)]="row.include"
                            [attr.aria-label]="'Create an identity for ' + row.address" />
                        <span class="si-row__addr">{{ row.address }}</span>
                        <svg class="si-row__to" aria-hidden="true" viewBox="0 0 24 24" width="15" height="15"
                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round">
                            <path d="M5 12h14M13 6l6 6-6 6" />
                        </svg>
                        <span class="si-row__name">{{ row.name }}</span>
                    </label>
                    }
                </div>
            </div>
        </section>
        } @else {
        <section class="nf-panel si-empty" aria-label="No source addresses">
            <p class="si-empty__title">No source addresses in this selection</p>
            <p class="si-empty__body">
                This traffic was initiated by identities, not raw addresses, so there is nothing to mint
                identities for.
            </p>
            <button type="button" class="nf-btn nf-btn--primary" (click)="skip()">Back to services</button>
        </section>
        }

        @if (rows.length) {
        <div class="si-actions">
            <span class="si-actions__spacer"></span>
            <button type="button" class="nf-btn nf-btn--secondary" (click)="skip()">Skip</button>
            <button type="button" class="nf-btn nf-btn--primary" [disabled]="!canContinue" (click)="create()">
                Create {{ includedCount }} {{ includedCount === 1 ? 'identity' : 'identities' }}
            </button>
        </div>
        }
    </div>
</div>
